<template>
  <div>
    <FormulateInput
      v-if="layer.display_mode === 'color'"
      :name="layer.id"
      :label="layer.title"
      type="colorswitch"
      :options="layer.options"
    />
    <FormulateInput
      v-if="layer.display_mode === 'dropdown'"
      :name="layer.id"
      :label="layer.title"
      type="select"
      :options="layer.options"
      input-class="form-select"
      placeholder="Select an option"
      @change="ChangeValueSelect"
    />
    <!-- <div v-if="this.messageLoading" class="message-loading-group SelectOption_loading">
      <div class="message-loading-div">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
    </div> -->
    <FormulateInput
      v-if="layer.display_mode === 'button'"
      :name="layer.id"
      :label="layer.title"
      type="buttongroup"
      :options="layer.options"
    />
    <FormulateInput
      v-if="layer.display_mode === 'image'"
      :name="layer.id"
      :label="layer.title"
      type="imageswitch"
      :options="
        layer.options.map(op => ({
          title: op.label,
          ...op
        }))
      "
      :showTitle="true"
    />
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'option-field',
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    fieldConfig() {
      const { layer, personalized } = this
      return [
        layer.id,
        {
          rules: [{ required: true, message: `${layer.title} is required` }],
          initialValue: get(personalized, layer.id)
        }
      ]
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    }
  },
  data(){
    return {
      messageLoading: true
    }
  },
  methods: {
    ChangeValueSelect(e){
      e.preventDefault()
      // let number_key = e.target.value.replace("option-","")
      // document.querySelector('.SelectOption_loading').style.display = 'block'
      // setTimeout(function(){
      //   document.querySelector('.SelectOption_loading').style.display = 'none'
      // }, 500*number_key)
    }
  }
}
</script>

<style>
form.omcustom-form.formulate-form {
  position: relative !important;
}
</style>

<style scoped>

.SelectOption_loading{
  display: none;
}


.message-loading-group {
  position: absolute !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Form/OptionField.vue